import React, { createContext, useState } from 'react';

export const SlugContext = createContext();

export const SlugProvider = ({ children }) => {
  const [slug, setSlug] = useState('');

  return (
    <SlugContext.Provider value={{ slug, setSlug }}>
      {children}
    </SlugContext.Provider>
  );
};